import { render } from "./DefaultLayout.vue?vue&type=template&id=7c1d9668"
import script from "./DefaultLayout.vue?vue&type=script&lang=ts"
export * from "./DefaultLayout.vue?vue&type=script&lang=ts"
script.render = render

export default script